import React from 'react';
import Section, {ISectionProps} from './components/section';

interface ISectionsProps {
  sections?: ISectionProps[];
  strictWidth?: boolean;
}

const Sections = (props: ISectionsProps) => {
  const existingSections = props.sections
    .filter(({children}) => children);
  if (existingSections.length > 0) {
    const lastExistingSection = existingSections[existingSections.length - 1];
    if (props.sections.indexOf(lastExistingSection) < props.sections.length - 1) {
      const freeWidth = props.sections.slice(props.sections.indexOf(lastExistingSection) + 1).reduce((sum, freeSection) => sum + freeSection.width, 0);
      lastExistingSection.width += freeWidth;
    }

    return (<>
      {existingSections
        .map((props, index) => <Section key={index} {...props} />)}
    </>);
  }
  return (null);
};

Sections.defaultProps = {
  sections: [],
  strictWidth: false,
};
export default Sections;
